import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import GallerySection from "./widget/GallerySection";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";



const Gallery = () => {
  return (
    <>
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Gallery"} />

        {/* GallerySection */}
        <GallerySection />

        {/* FooterOne */}
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Gallery;
